module.exports = __webpack_public_path__ + "static/iron_flask-da79a39a04309fb517365a3f97ce80a9.jpeg";